// export const API_URL = "https://pp-syncsalesforce.metro-tr.com/";
// export const CSS_API_URL = "https://customsalesforce.metro-tr.com";
// export const AXIOS_API_URL = "https://pp-microservices.metro-tr.com/"
export const API_URL = window.Configs.API_URL;
export const CSS_API_URL = window.Configs.CSS_API_URL;
export const AXIOS_API_URL = window.Configs.AXIOS_API_URL;
/* export const AXIOS_API_URL = "https://localhost:44358/api/Influencer/" */